module.exports = __webpack_public_path__ + "media/images/logo-beta-45b59d7e276748a678ac6ce05b25179d.svg";